import { render, staticRenderFns } from "./Campo.vue?vue&type=template&id=4b505170&scoped=true"
import script from "./Campo.vue?vue&type=script&lang=js"
export * from "./Campo.vue?vue&type=script&lang=js"
import style0 from "./Campo.vue?vue&type=style&index=0&id=4b505170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b505170",
  null
  
)

export default component.exports